import React from 'react';
import { Link } from 'react-router-dom';

const Hero = () => {

  return (
    <div
      className="hero h-96 mt-16"
      style={{ backgroundImage: "url('/spencer-demera-livermore-unsplash.jpg')" }}
    >
      <div className="hero-overlay bg-opacity-60"></div>
      <div className="hero-content text-center text-white pb-0">
        <div className="max-w-xl">
          <h1 className="font-heading text-5xl font-bold">Livermore Odd Fellows</h1>
          <p className="py-6">Independent Order of Odd Fellows Lodge #219</p>
          <Link to="/membership"
          className="btn btn-lg text-xl rounded-lg font-heading font-bold bg-[#012F47] border-[#012F47] hover:bg-[#631F07] text-white" 
          >Join the Livermore Odd Fellows</Link>
        </div>
      </div>
    </div>
  )
}

export default Hero;